import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.BUSINESS };
const path = "business/reports";


export const TransactionGraphData = async (values) => {
  return await axiosInstance(options).post(`${path}/transactions-graph-data`, values);
};

export const UserGraphData = async (values) => {
  return await axiosInstance(options).post(`${path}/user-graph-data`, values);
};



